import getFp from 'lodash/fp/get';
import getOrFp from 'lodash/fp/getOr';

export const isHidden = getFp('redacted');
export const isLoved = getFp('loved');
export const isUnseen = getFp('unseen');
export const getMergedIdeas = getOrFp([], 'mergedIdeas');
